<template>
  <SharedSalesToolbar
    mode="flat-rates"
    :show-customer-filter="showCustomerFilter"
    :initial-date-preset-key="initialDatePresetKey"
    @search-change="forwardSearchChange"
    @filters-change="forwardFiltersChange"
    @apply="forwardApply"
  />
</template>

<script>
import SharedSalesToolbar from '@/components/sales/shared/SalesToolbar.vue';

export default {
  name: 'SalesFlatRatesToolbar',
  components: {
    SharedSalesToolbar,
  },
  props: {
    showCustomerFilter: {
      type: Boolean,
      default: true,
    },
    initialDatePresetKey: {
      type: String,
      default: 'this_year',
    },
  },
  emits: ['search-change', 'filters-change', 'apply'],
  methods: {
    forwardSearchChange(value) {
      this.$emit('search-change', value);
    },
    forwardFiltersChange(...args) {
      this.$emit('filters-change', ...args);
    },
    forwardApply(payload) {
      this.$emit('apply', payload);
    },
  },
};
</script>
